import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import { Tooltip } from 'antd'
import { Icon, Div, P } from 'konsys-ui'
import { ChevronsUpDown } from 'lucide-react'
import { status, statusText } from '../constants'
import {
  InputWithPlaceHolder, StatusSelector, ActionSelector, HeaderLabel, CellText, DropdownSelector, IsPaidByFleetCardToggle,
} from '../../../components/filling-order-components'
import { theme } from '../../../styles/_variables'
import { DatePicker } from '../styled'

const { color } = theme

export const colorSelector = (e) => {
  switch (e) {
    case status.WAITING:
      return color.coolGrey
    case status.EXPIRED:
      return color.error
    case status.FILLED:
      return color.success
    case status.BILLED:
      return color.info
    case status.PRINTED:
      return color.wildWillow
    case status.CANCELLED:
      return color.error
    case status.LOST:
      return color.lost
    default:
      return color.black
  }
}

export const textSelector = (e) => {
  switch (e) {
    case status.WAITING:
      return statusText.WAITING
    case status.EXPIRED:
      return statusText.EXPIRED
    case status.FILLED:
      return statusText.FILLED
    case status.BILLED:
      return statusText.BILLED
    case status.PRINTED:
      return statusText.PRINTED
    case status.CANCELLED:
      return statusText.CANCELLED
    case status.LOST:
      return statusText.LOST
    default:
      return 'ไม่ระบุ'
  }
}

export const mobileColorSelector = (e) => {
  switch (e) {
    case status.WAITING:
    case status.PRINTED:
      return color.wildWillow
    case status.EXPIRED:
      return color.error
    case status.FILLED:
      return color.success
    case status.BILLED:
      return color.info
    case status.CANCELLED:
      return color.error
    case status.LOST:
      return color.lost
    default:
      return color.black
  }
}

export const mobileTextSelector = (e) => {
  switch (e) {
    case status.WAITING:
    case status.PRINTED:
      return statusText.CANBEUSED
    case status.EXPIRED:
      return statusText.EXPIRED
    case status.FILLED:
      return statusText.FILLED
    case status.BILLED:
      return statusText.BILLED
    case status.CANCELLED:
      return statusText.CANCELLED
    case status.LOST:
      return statusText.LOST
    default:
      return 'ไม่ระบุ'
  }
}

export default {
  columns: [{
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          เล่มที่ <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'shippingVolume',
    sortable: true,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)} />,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 100,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          เลขที่ <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'shippingNumber',
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)} />,
    filterMethod: (filter, row) => _.includes(row.fullname, filter.value),
    sortable: true,
    filterable: true,
    width: 100,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          วันที่ครบกำหนด <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'expiredDate',
    sortable: true,
    filterable: true,
    Cell: props => <CellText>{props.value ? moment(props.value).format('DD/MM/YY') : ''}</CellText>,
    Filter: ({ onChange }) => <DatePicker format='DD/MM/YY' onChange={e => onChange(_.isNull(e) ? undefined : moment(e).format('YYYY-MM-DD'))} />,
    filterMethod: (filter, row) => _.includes(row.clientId, filter.value),
    width: 150,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          ชื่อสถานี
        </HeaderLabel>
      </Div>
    ),
    accessor: 'Gasstation.name',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)} />,
    filterMethod: (filter, row) => _.includes(row.clientId, filter.value),
    width: 150,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          บริษัท
        </HeaderLabel>
      </Div>
    ),
    accessor: 'Gasstation.company',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <DropdownSelector
      key='filter'
      data={[{
        value: 'ALL',
        text: 'ทั้งหมด',
      }, {
        value: 'SHELL',
        text: 'SHELL',
      }, {
        value: 'BANGCHAK',
        text: 'BANGCHAK',
      }, {
        value: 'CALTEX',
        text: 'CALTEX',
      }, {
        value: 'ESSO',
        text: 'ESSO',
      }, {
        value: 'PTT',
        text: 'PTT',
      }, {
        value: 'PT',
        text: 'PT',
      }, {
        value: 'OTHER',
        text: 'OTHER',
      }]}
      handleChange={e => onChange(e)}
      filter={true}
      statusAttr='ทั้งหมด'
      typeNameTh={true}
    />,
    filterMethod: (filter, row) => _.includes(row.clientId, filter.value),
    width: 150,
  }, {
    Header: () => (
      <div className='text-start'>
        <HeaderLabel>ประเภท</HeaderLabel>
      </div>
    ),
    id: 'isSpecial',
    accessor: 'isSpecial',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{props.value ? 'ใบเบิกน้ำมันพิเศษ' : 'ใบเบิกน้ำมัน'}</CellText>,
    Filter: ({ onChange }) => <DropdownSelector
      key='type-filter'
      width='150px'
      data={[
        {
          value: 'ALL',
          text: 'ทั้งหมด',
        },
        {
          value: 'NORMAL',
          text: 'ใบเบิกน้ำมัน',
        },
        {
          value: 'SPECIAL',
          text: 'ใบเบิกน้ำมันพิเศษ',
        },
      ]}
      handleChange={e => onChange(e)}
      typeNameTh={true}
    />,
    width: 180,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          ปริมาณที่เติมแล้ว(ลิตร)
        </HeaderLabel>
      </Div>
    ),
    accessor: 'filledAmount',
    sortable: false,
    filterable: false,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)} />,
    filterMethod: (filter, row) => _.includes(row.clientId, filter.value),
    width: 140,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          ปริมาณทั้งหมด(ลิตร)
        </HeaderLabel>
      </Div>
    ),
    accessor: 'totalAmount',
    sortable: false,
    filterable: false,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)} />,
    filterMethod: (filter, row) => _.includes(row.clientId, filter.value),
    width: 140,
  }, {
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          จ่ายเงินด้วย FleetCard
        </HeaderLabel>
      </Div>
    ),
    accessor: 'isPaidByFleetCard',
    sortable: false,
    filterable: false,
    Cell: props => <Div display='flex' justifyContent='center'><IsPaidByFleetCardToggle defaultChecked={props.value} id={props.original.id} /></Div>,
    width: 140,
  }, {
    Header: <HeaderLabel>สถานะ</HeaderLabel>,
    accessor: 'status',
    sortable: false,
    filterable: true,
    Cell: props => (
      <P bold color={colorSelector(props.value)}>{textSelector(props.value)}</P>
    ),
    filterMethod: (filter, row) => filter.value === row.status || filter.value === 'ALL',
    Filter: ({ onChange }) => <StatusSelector key='filter' statusAttr='ทั้งหมด' handleChange={e => onChange(e)} filter={true} />,
    width: 140,
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelector refetch={() => props.tdProps.rest.refetch()} props={props} />,
    width: 150,
  }],
}
